export enum TanstackQueryKey {
  TRAINER_WORKING_DAYS = "trainer-working-days",
  USER_DETAIL = "user-detail",
  CLASS_LIST = "class-list",
  CLASS_DETAIL = "class-detail",
  TRAINER_LIST = "trainer-list",
  TRAINER_SCHEDULE = "trainer-schedule",
  TRAINER_AVAILABILITY = "trainer-availability",
  TRAINER_SERVICE_GROUPS = "trainer-service-groups",
  SERVICES = "services",
  BOOKING_FIND_MEMBERSHIP = "booking-find-membership",
  FACILITY_FIND_MEMBERSHIP = "facility-find-membership",
  MEMBERSHIP_DETAIL = "membership-detail",
  CLASS_SCHEDULE_LIST = "class-schedule-list",
  CLASS_SCHEDULE_DETAIL = "class-schedule-detail",
  MEMBER_BOOKING = "member-booking",
  MEMBER_CLASS_BOOKING = "member-class-booking",
  MEMBER_SWIMMING_BOOKING = "member-swimming-booking",
  MEMBER_PROFILE = "member-profile",
  MEMBER_CHECKIN_QR = "member-checkin-qr",
  MEMBER_CREDIT_TRANSACTIONS = "member-credit-transactions",
  MEMBER_CREDIT_BALANCE = "member-credit-balance",
  MEMBER_GOAL_SETTINGS = "member-goal-settings",
  GOAL_SETTING_DETAIL = "goal-setting-detail",
  GOAL_SETTING_SESSIONS = "goal-setting-sessions",
  GOAL_SETTING_SESSION_DETAIL = "goal-setting-session-detail",
  FACILITY_LIST = "facility-list",
  FACILITY_DETAIL = "facility-detail",
  FACILITY_BOOKING_LIST = "facility-booking-list",
  FACILITY_BOOKING_DETAIL = "facility-booking-detail",
  FACILITY_DAY_SLOTS = "facility-day-slots",
  FACILITY_AVAILABILITY_DAYS = "facility-availability-days",
  FACILITY_BOOKING_CONFIG = "facility-booking-config",
  FACILITY_HELD_BOOKING = "facility-held-booking",
  WALK_IN_BRANCHES = "walk-in-branches",
  WALK_IN_FACILITIES = "walk-in-facilities",
  WALK_IN_FACILITY = "walk-in-facility",
  WALK_IN_BOOKING = "walk-in-booking",
  WALK_IN_BANK_ACCOUNTS = "walk-in-bank-accounts",
  MEMBER_QR_PAYMENT = "member-qr-payment",
  CLUB_INFO = "club-info",
  CLUB_BANK_ACCOUNTS = "club-bank-accounts",
  PUBLIC_CLUB_INFO = "public-club-info",
  MEMBER_STATUS = "member_status",
  LOYALTY_BALANCE = "loyalty-balance",
  LOYALTY_EARNING_HISTORY = "loyalty-earning-history",
  LOYALTY_REDEMPTION_HISTORY = "loyalty-redemption-history",
  LOYALTY_REWARDS = "loyalty-rewards",
  LOYALTY_BENEFITS = "loyalty-benefits",
  IS_MULTI_BRANCH = "is-multi-branch",
  MEMBERSHIP_BRANCHES = "membership-branches",
  LIFF_BRANCH = "liff-branch",
  ROLE_CATEGORIES = "role-categories",
  SWIMMING_COACHES = "swimming-coaches",
  SWIMMING_COACH_SLOTS = "swimming-coach-slots",
}
